import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { strip_test_public_key } from "../../env";
import { useSelector } from "react-redux";

const stripePromise = loadStripe(strip_test_public_key);
export const AddNewCard = ({ close }) => {

    const [clientSecret, setClientSecret] = useState("");
    const [isSubmitting, setSubmitting] = useState(false);

    const userId = useSelector( state => state.user.userId);
    const firstname = useSelector((state) => state.user.firstName); 
    const lastname = useSelector((state) => state.user.lastName);
    const email = useSelector((state) => state.user.email);

    useEffect(() => {
      fetch(
        "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/save-card-intent.php",
        {
          method: "POST",
          body: JSON.stringify({
            email: email,
            name: `${firstname} ${lastname}`,
            userId: userId,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      ) // adjust to your backend
        .then((res) => res.json())
        .then((data) => setClientSecret(data.clientSecret));
    }, []);

    const appearance = { theme: "stripe" }; // or 'flat', 'night', etc.
    const options = {
      clientSecret,
      appearance,
      locale: "en",
      defaultValues: {
        billingDetails: {
          address: {
            country: "US", // India
          },
        },
      },
    };

    return (
      <div
        className="modal fade"
        id="addNewCard"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-dark px-2 pb-2">
            <div className="modal-header border-0 pb-0">
              <h4 className="modal-title text-white" id="staticBackdropLabel">
                Add New Card
              </h4>
              <button
                type="button"
                className="btn btn-link p-0 text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <IoMdClose fontSize="25px" />
              </button>
            </div>
            <div className="modal-body">
              {/* <div className="card">
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-9 pr-2">
                      <div className="form-group">
                        <label for="cardNumber" className="f-14 mb-1">
                          Card Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cardNumber"
                          placeholder="**** **** **** 1234"
                        />
                      </div>

                      <div className="form-group">
                        <label for="cardName" className="f-14 mb-1">
                          Cardholder Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cardName"
                          placeholder="Susan 3For3"
                        />
                      </div>
                    </div>

                    <div className="col-3 pl-2">
                      <div className="form-group">
                        <label for="cardCvv" className="f-14 mb-1">
                          CVV
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cardCvv"
                          aria-describedby="cvvHelp"
                        />
                        <small
                          id="cvvHelp"
                          className="form-text text-muted"
                          style={{ fontSize: 10 }}
                        >
                          The last 4 digits on back of the card
                        </small>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label for="expirationDate" className="f-14 mb-1">
                          Expiration Date
                        </label>
                        <div className="d-flex w-50">
                          <input
                            type="text"
                            className="form-control mr-2"
                            id="expirationDate"
                            placeholder="MM"
                          />
                          <input
                            type="text"
                            className="form-control"
                            id="expirationDate"
                            placeholder="YY"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {clientSecret ? (
                <Elements stripe={stripePromise} options={options}>
                  <Card
                    onCardSaved={() => {
                      setClientSecret(null);
                      close(false);
                    }}
                    isSubmitting={isSubmitting}
                    setSubmitting={setSubmitting}
                  />
                </Elements>
              ) : (
                <div className="align-items-center d-flex flex-column">
                  <div className="spinner-border text-white" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="text-white text-center mt-3">
                    {isSubmitting
                      ? "Saving your card securely. Please wait..."
                      : "Please wait form is Loading..."}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
}

export const Card = ({
  onCardSaved,
  isSubmitting,
  setSubmitting,
}) => {
  const closeBtnRef = useRef();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setSubmitting(true);
    const { setupIntent, error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href, // not needed if you're handling everything client-side
      },
      redirect: "if_required",
    });

    setSubmitting(false);

    if (error) {
      console.error(error);
      alert(error.message);
    } else if (setupIntent.status === "succeeded") {
      console.log(closeBtnRef.current);
      if (closeBtnRef.current) {
        closeBtnRef.current?.click();
      }
      onCardSaved(); // Reload card list or close modal
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <div className="d-flex justify-content-end mt-3">
        <button
          id="modalCloseBtn"
          ref={closeBtnRef}
          type="button"
          className="btn btn-secondary btn-sm bg-white text-dark mr-3 rounded-10"
          data-dismiss="modal"
          style={{ minWidth: 80 }}
        >
          Cancel
        </button>

        <button
          type="submit"
          disabled={!stripe || isSubmitting}
          className="btn btn-primary btn-sm rounded-10"
          style={{ minWidth: 80 }}
        >
          {isSubmitting ? "Saving..." : "Add Card"}
        </button>
      </div>
    </form>
  );
};